import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const VirtualTour = ({
  color,
  width,
  height,
  x = '0px',
  y = '0px',
  scale = 0,
}: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '22px'}
      height={height || '22px'}
      color={color || 'currentColor'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path d="M2,6.24l9,4.23l9-4.23" stroke={color || 'currentColor'} strokeWidth="1" />
      <path d="M11,10.47V20" stroke={color || 'currentColor'} strokeWidth="1" />
      <path
        d="M2,6.24L11,2l9,4.24v9.53L11,20l-9-4.23V6.24z"
        stroke={color || 'currentColor'}
        strokeWidth="1"
      />
    </StyledSvg>
  );
};
